// React
import { Fragment } from "react"

// Third-Party Library
import useToggle from "@react-hook/toggle"
import PropTypes from "prop-types"

// Components
import { ActionButton, Calendar, Checkbox, Input } from "components"
import { Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

// Form
import { Formik } from "formik"
import * as yup from "yup"

// Functions
import { dateConvert, errorCheck, toast, validation } from "functions"

// API
import { Api } from "../../api"

const DepartureSection = props => {
  // Variables
  const today = new Date()

  // Hooks
  const [show, toggle] = useToggle(false, true)

  const ModalRequest = ({ toggle }) => (
    <Modal isOpen={true} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Request Transportation
      </ModalHeader>

      <Formik
        initialValues={{
          category_id: props.id,
          name: "",
          email: "",
          pax: "",
          date: dateConvert(new Date(today.setDate(today.getDate() + 1))).default.format,
          notes: "",
          term: false
        }}
        validationSchema={yup.object().shape({
          name: yup.string().label("Name").required(),
          email: yup.string().email().label("Email").required(),
          pax: yup.number().typeError(validation().number.label).label("Pax").min(1).required(),
          date: yup.string().label("Date").required(),
          term: yup.boolean().label("Term").required().oneOf(validation().mustAccept.value, validation().mustAccept.label)
        })}
        onSubmit={(values, { setSubmitting }) => {
          Api.request_store(values).then(res => {
            toast('success', res.data.message)
            toggle()
          }).catch(err => {
            toast("error", err.response.data.message)
          }).finally(() => {
            setSubmitting(false)
          })
        }}
      >
        {({errors, isSubmitting, touched, values, handleChange, setFieldValue, handleSubmit}) => (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <Input
                label="Name"
                name="name"
                onChange={handleChange}
                value={values.name}
                errors={errorCheck(errors, touched, "name")}
              />

              <Input
                label="Email"
                name="email"
                type="email"
                onChange={handleChange}
                value={values.email}
                errors={errorCheck(errors, touched, "email")}
              />

              <Input
                label="Pax"
                name="pax"
                type="number"
                onChange={handleChange}
                value={values.pax}
                errors={errorCheck(errors, touched, "pax")}
              />

              <Calendar
                label="Departure Date"
                errors={errorCheck(errors, touched, "date")}
                value={new Date(values.date)}
                onChange={e => setFieldValue('date', dateConvert(e).default.format)}
              />

              <Input
                label="Message"
                name="notes"
                type="textarea"
                errors={errorCheck(errors, touched, "notes")}
                rows={4}
                value={values.notes}
                onChange={handleChange}
              />

              <Checkbox
                onChange={() => setFieldValue('term', !values.term)}
                value={values.term}
                errors={Boolean(errors.term && touched.term) && errors.term}
              >
                Transport is subject to availability. Requests must be made at least one working day prior to the departure date.
              </Checkbox>
            </ModalBody>

            <ModalFooter>
              <ActionButton
                className="text-white"
                color="primary"
                type="submit"
                loading={isSubmitting}
              />
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  )

  return (
    <Fragment>
      <ActionButton
        className="text-white m-1"
        size="lg"
        onClick={toggle}
      >
        REQUEST
      </ActionButton>

      {show && <ModalRequest toggle={toggle} />}
    </Fragment>
  )
}

DepartureSection.propTypes = {
	id: PropTypes.string.isRequired
}

export { DepartureSection }